import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const useQueryParam = (paramName: string) => {
  const [searchParams] = useSearchParams();
  const [paramValue, setParamValue] = useState<string | null>(null);

  useEffect(() => {
    const value = searchParams.get(paramName);
    setParamValue(value);
  }, [searchParams, paramName]);

  return paramValue;
};

export const useQueryParamLegacy = (paramName: string) => {
  const [paramValue, setParamValue] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(paramName);
    setParamValue(value);
  }, [paramName]);

  return paramValue;
};
